<main class="container-fluid">
    <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
        <section class="col-12 p-4 mb-5">

            <div class="d-flex justify-content-between">
                <div>
                    <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3"
                        alt="">
                    <label class="h5">Listado de reporte Encuesta Satisfacci&oacute;n</label>
                </div>
                <p>
                    <button type="button" class="btn btn-outline-success mr-3"
                        [disabled]="!dataTabla?.items || dataTabla.items?.length === 0"
                        (click)="submit()">Exportar</button>
                    <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
                        [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
                        Ver filtros
                    </button>
                </p>
            </div>
            <div id="filtros" [ngbCollapse]="isCollapsed">
                <div class="card mb-3">
                    <div class="card-body">
                        <form [formGroup]="filtro" (submit)="filtrar()">
                            <div class="row">
                                <div class="col-2 form-group">
                                    <label class="small text-secondary required" for="encuesta_satisfaccion_id">Encuesta
                                        Satisfacci&oacute;n</label>
                                    <select class="form-control form-control-sm" id="encuesta_satisfaccion_id"
                                        formControlName="encuesta_satisfaccion_id">
                                        <option class="" value="" selected="true">
                                            Seleccione
                                        </option>
                                        <option class="" *ngFor="let option of listaEncuestas; let i = index"
                                            value="{{option?.id}}" [selected]="false">
                                            {{option?.nombre}}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-2 form-group">
                                    <label class="text-secondary small required">Fecha Inicial</label>
                                    <div class="input-group">
                                        <input class="form-control form-control-sm" formControlName="fechaInicial"
                                            placeholder="yyyy/mm/dd" ngbDatepicker #inicio="ngbDatepicker"
                                            (dateSelect)="onCheckDate($event)">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary calendar" (click)="inicio.toggle()"
                                                type="button"></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 form-group">
                                    <label class="text-secondary small required">Fecha Final</label>
                                    <div class="input-group">
                                        <input class="form-control form-control-sm" formControlName="fechaFinal"
                                            placeholder="yyyy/mm/dd" ngbDatepicker #fin="ngbDatepicker"
                                            [minDate]="fecha_inicio">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary calendar" (click)="fin.toggle()"
                                                type="button"></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 form-group" *ngIf="!authService.getRolUser(adminCC)">
                                    <label class="small text-secondary" for="codigo_camara">Cámara de comercio</label>
                                    <select class="form-control form-control-sm" id="codigo_camara"
                                        formControlName="codigo_camara" (change)="cargarListaFuncionario()">
                                        <option class="" value="" selected="true">
                                            Seleccione
                                        </option>
                                        <option class="" *ngFor="let option of camarasLista; let i = index"
                                            value="{{option?.codigo_camara}}" [selected]="false">
                                            {{option?.desc_camara}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-2 form-group">
                                    <label class="text-secondary small">Nit</label>
                                    <div class="input-group">
                                        <input class="form-control form-control-sm" formControlName="nit"
                                            placeholder="nit">
                                    </div>
                                </div>
                                <div class="col-2 form-group">
                                    <label class="text-secondary small">Razón social</label>
                                    <div class="input-group">
                                        <input class="form-control form-control-sm" formControlName="razon_social"
                                            placeholder="Razón social">
                                    </div>
                                </div>
                                <div class="col-2 form-group">
                                    <label class="text-secondary small">Prestador</label>
                                    <div class="input-group">
                                        <input class="form-control form-control-sm" formControlName="prestador"
                                            placeholder="Prestador">
                                    </div>
                                </div>
                                <div class="d-flex flex-row">
                                    <button type="button"
                                        class="btn btn-outline-primary border-0 m-auto btn-align-vertical"
                                        (click)="limpiar();">Limpiar</button>
                                    <button class="btn btn-primary m-auto solicitud-btn-principal btn-align-vertical"
                                        type="submit" [disabled]="!filtro.valid">Filtrar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!--Aqui va el detalle-->
            <div class="table-responsive">
                <table class="table table-hover" *ngIf="header">
                    <thead>
                        <tr>
                            <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                                [rowSpan]="header.maxFila">
                                <label>{{header.descripcion_camara}}</label>
                            </th>
                            <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                                [rowSpan]="header.maxFila">
                                <label>{{header.razon_social}}</label>
                            </th>
                            <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                                [rowSpan]="header.maxFila">
                                <label>{{header.nit}}</label>
                            </th>
                            <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                                [rowSpan]="header.maxFila">
                                <label>{{header.correo_electronico}}</label>
                            </th>
                            <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                                [rowSpan]="header.maxFila">
                                <label>{{header.telefono}}</label>
                            </th>
                            <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                                [rowSpan]="header.maxFila">
                                <label>{{header.usuario}}</label>
                            </th>
                            <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                                [rowSpan]="header.maxFila">
                                <label>{{header.fecha_finalizacion}}</label>
                            </th>
                            <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                                [rowSpan]="header.maxFila">
                                {{header.nombre_encuesta}}
                            </th>
                            <ng-container *ngFor="let modulo of header.preguntas; let i = index">
                                <th class="border-top-0 pb-1 small font-weight-bold align-text-top" scope="col"
                                    [colSpan]="modulo.columnSpan">
                                    {{modulo.titulo}}
                                    <!-- <label>{{modulo.descripcion}}</label> -->
                                </th>
                            </ng-container>
                        </tr>
                    </thead>
                    <tfoot *ngIf="dataTabla?.items && dataTabla.items.length > 0; else sinPaginado">
                        <tr>
                            <td colspan="100%">
                                <ngb-pagination class="d-flex justify-content-center"
                                    [collectionSize]="dataTabla.paging.totalItems"
                                    [pageSize]="dataTabla.paging.pageSize" (pageChange)="onPaginado($event)"
                                    [(page)]="dataTabla.paging.pageNumber" [maxSize]="5" [rotate]="true"
                                    [boundaryLinks]="true" size="sm">
                                </ngb-pagination>
                            </td>
                        </tr>
                    </tfoot>
                    <ng-template #sinPaginado>
                        <tfoot>
                            <label class="text-muted">Sin registros</label>
                        </tfoot>
                    </ng-template>
                    <ng-container *ngFor="let item of dataTabla?.items; let i=index">
                        <tr class="small">
                            <td>
                                <label>{{item.desc_camara}}</label>
                            </td>
                            <td>
                                <label>{{item.razon_social}}</label>
                            </td>
                            <td>
                                <label>{{item.nit}}</label>
                            </td>
                            <td>
                                <label>{{item.correo_electronico}}</label>
                            </td>
                            <td>
                                <label>{{item.telefono}}</label>
                            </td>
                            <td>
                                <label>{{item.usuario}}</label>
                            </td>
                            <td>
                                <label>{{item.fecha_final}}</label>
                            </td>
                            <td>
                                <label>{{item.nombre_encuesta}}</label>
                            </td>
                            <ng-container *ngFor="let dato of getEntries(item.preguntas)">
                                <td [innerHTML]="dato.respuesta"></td>
                            </ng-container>
                        </tr>
                    </ng-container>
                </table>
            </div>

        </section>
    </article>
</main>